export default __webpack_public_path__ + "static/media/pirate.ae1f0804.gif";